import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const Coomera = () => (
  <CostcoLocationTemplate
    warehouseName="Gold Coast"
    suburb="Coomera"
    state="Queensland"
    stateShort="QLD"
    address="Foxwell Rd, Coomera QLD 4209"
    path="/costco/gold-coast"
    nearbySuburbs={[
      'Coomera',
      'Upper Coomera',
      'Pimpama',
      'Ormeau',
      'Oxenford',
      'Helensvale',
      'Hope Island',
      'Pacific Pines',
      'Nerang',
      'Maudsland',
    ]}
    description="Manage Your Loans is the exclusive Costco member loan partner serving the Gold Coast warehouse in Coomera and the northern Gold Coast corridor. Whether you're purchasing a lifestyle property, investing in the tourism-driven economy, or buying your first home in one of the area's thriving new estates, our brokers can help you earn Costco Shop Card rewards on settled loans."
    localContext={[
      'The Gold Coast northern corridor — spanning Coomera, Pimpama, and Ormeau — is one of Australia\'s fastest-growing residential areas, with strong demand for new family homes and townhouses.',
      'The Gold Coast lifestyle economy, driven by tourism, hospitality, and major events, creates unique lending opportunities including holiday rental investment properties.',
      'Significant infrastructure investment including the Coomera Connector and Light Rail extension is boosting property values and making the northern corridor increasingly attractive to buyers.',
    ]}
    faqs={[
      {
        q: 'How does the Costco Shop Card offer work at the Gold Coast warehouse?',
        a: 'As a Costco Executive Member, simply apply for a loan through Manage Your Loans. Once your loan settles, you\'ll receive a Costco Shop Card reward redeemable at the Coomera warehouse or any Costco in Australia.',
      },
      {
        q: 'Can I get an investment property loan for a Gold Coast rental?',
        a: 'Yes. Investment property loans are one of our core products, and the Gold Coast\'s strong rental yields and tourism-driven demand make it a popular choice. Executive Members earn Shop Card rewards on settled investment loans too.',
      },
      {
        q: 'Which Gold Coast suburbs does this service cover?',
        a: 'We serve all northern Gold Coast suburbs including Coomera, Upper Coomera, Pimpama, Ormeau, Oxenford, Helensvale, Hope Island, Pacific Pines, Nerang, and Maudsland. You can also apply from anywhere on the Gold Coast.',
      },
      {
        q: 'Are there special rates for first home buyers on the Gold Coast?',
        a: 'Our brokers can access competitive first home buyer rates from a wide panel of lenders. Queensland\'s First Home Owner Grant may also apply for new builds, and your Costco Shop Card reward provides additional value on settlement.',
      },
    ]}
    suburbData={{
      suburb: 'Coomera',
      medianHouse: '$720,000',
      medianUnit: '$480,000',
      daysOnMarket: '25 days',
      rentalYield: '4.2%',
      population: '18,000',
      distanceToCostco: '2 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Upper Coomera', medianHouse: '$750,000', medianUnit: '$500,000', daysOnMarket: '24 days' },
      { suburb: 'Pimpama', medianHouse: '$680,000', medianUnit: '$460,000', daysOnMarket: '22 days' },
      { suburb: 'Ormeau', medianHouse: '$720,000', medianUnit: '$480,000', daysOnMarket: '25 days' },
      { suburb: 'Oxenford', medianHouse: '$780,000', medianUnit: '$510,000', daysOnMarket: '23 days' },
      { suburb: 'Helensvale', medianHouse: '$920,000', medianUnit: '$560,000', daysOnMarket: '21 days' },
      { suburb: 'Hope Island', medianHouse: '$1,050,000', medianUnit: '$600,000', daysOnMarket: '20 days' },
      { suburb: 'Pacific Pines', medianHouse: '$830,000', medianUnit: '$520,000', daysOnMarket: '24 days' },
      { suburb: 'Nerang', medianHouse: '$760,000', medianUnit: '$490,000', daysOnMarket: '26 days' },
      { suburb: 'Maudsland', medianHouse: '$850,000', medianUnit: '$530,000', daysOnMarket: '23 days' },
    ]}
  />
);

export default Coomera;
